import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { timer } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class StaffProvider {

  constructor(public http: HttpClient, private storage: Storage) {
    console.log('Hello StaffProvider Provider');
  }

  URL = environment.vmsUrl;

  getStaffs(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/v1/society/${val.societyId}/${val.id}/staffs`,val))
        .toPromise();
      }
    });
  }

  getStaffById(id: number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/v1/society/${val.societyId}/getStaffDetailsById`,val)+`&id=${id}`)
        .toPromise();
      }
    });
  }

  searchStaffs(input: string){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/v1/society/${val.societyId}/staff/search`,val)+`&input=${input}`)
        .toPromise();
      }
    });
  }

  getStaffCategories(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/v1/society/${val.societyId}/allstaffcategory`,val))
        .toPromise();
      }
    });
  }

  getStaffByCategories(input: string){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/v1/society/${val.societyId}/staffbycategory`,val)+`&category=${input}`)
        .toPromise();
      }
    });
  }

  getReviews(id: number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/v1/society/${val.societyId}/getStaffRatingByStaffId`,val)+`&staff_id=${id}`)
        .toPromise();
      }
    });
  }

  submitReview(data: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/addOrUpdateRating`,val),data)
        .toPromise();
      }
    });
  }

  attendance(staffId: number,month: number, year: number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/v2/society/${val.societyId}/staffattendance`,val)+`&month=${month}&year=${year}&staff_id=${staffId}`)
        .toPromise();
      }
    });
  }

  release(id: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/unassignStaff`,val),{
          staff_id: id,
          user: val.id
        })
        .toPromise();
      }
    });
  }

  associate(id: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/assignStaff`,val),{
          staff_id: id,
          user: {
            flat_no: val.flat_no, id: `${val.id}`, name: val.name
          }
        })
        .toPromise();
      }
    });
  }

  notification(staffId, value){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/v1/society/${val.societyId}/staffnotification`,val),{
          staff_id: staffId,
          user: val.id,
          value: value
        })
        .toPromise();
      }
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(link: string, val: any):string {
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}


// WEBPACK FOOTER //
// ./src/providers/staff/staff.ts